export default "__VITE_ASSET__Cwbvv3DB__"